import React from 'react';

export const VideoIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M17022,2428a8,8,0,1,0,8,8A8.011,8.011,0,0,0,17022,2428Zm2.8,8.42-4,2.5a0.674,0.674,0,0,1-.3.08,0.212,0.212,0,0,1-.2-0.06,0.477,0.477,0,0,1-.3-0.44v-5a0.533,0.533,0,0,1,.8-0.42l4,2.5A0.541,0.541,0,0,1,17024.8,2436.42Z"
      transform="translate(-17014 -2428)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/video-icon.js